<template>
  <div class="center-btn">
    <div @click="btnClick('reset','')" class="reset">
      <img src="@/assets/image/index/复位@2x.png" alt=""></img>
    </div>
    <div class="scanle">
      <img @click="btnClick('dec','')" src="@/assets/image/index/缩小@2x.png" alt=""></img>
      <div class="scanle-content">{{ ratio }}%</div>
      <img @click="btnClick('add','')" src="@/assets/image/index/放大@2x.png" alt=""></img>
    </div>
    <div class="data-list">
      <div class="btn-item" @click="btnClick('changeFlag',item.desec)" v-for ='item in dataList' :key="item.desec">
        <img class="item-img" :src="item.imgUrl"/>
        <div class="data-desc">{{ item.desec }} &nbsp;{{  allData[item.props]}}</div>
      </div>
    </div>
  </div>
</template>
<script >
export default{
  props:{
    equipmentPropData: {
      default: {}
    }
  },
  data(){
    return {
      dataList:[
        {
          imgUrl:require('@/assets/image/index/实名制数据.png'),
          desec:'实名制通道',
          props:'realNameEquipmentNum'
        },
        {
          imgUrl:require('@/assets/image/index/视频数据.png'),
          desec:'视频监控',
          props:'videoEquipmentNum'
        },{
          imgUrl:require('@/assets/image/index/塔吊数据.png'),
          desec:'扬尘监测',
          props:'environmentEquipmentNum'
        }
      ],
      allData:{},
      ratio:100
    }
  },
  watch:{
    equipmentPropData(){
      this.allData = this.equipmentPropData;
    }
  },
  created(){

  },
  methods:{
    btnClick(type,data){
      const mapFn ={
        reset: ()=>{
          this.ratio = 100;
          this.$emit('btnClick','reset',this.ratio);

        },
        dec: ()=>{
          if(this.ratio <= 0)return;
          this.ratio--
          this.$emit('btnClick','changRatio','dec');

        },
        add:()=>{
          if(this.ratio >= 200)return;
          this.ratio++
          this.$emit('btnClick','changRatio','add');

        },
        changeFlag:()=>{
          if(this.ratio >= 100)return;
          this.ratio++
          this.$emit('btnClick','changFlag',data);
        },

      }
      mapFn[type]();
    }
  }
}
</script>
<style scoped lang="scss">
.center-btn{
  display: flex;
  align-items: center;
  gap: 24px;
  .reset,.scanle{
    border-radius: 6px;
    background: rgba(62,71,84,0.7);
    img{
      width: 24px;
      height:24px;
    }
  }
  .reset{
    padding: 12px;
  }
  .scanle{
    display: flex;
    align-items: center;
    padding: 8px 12px;
    gap: 16px;
    .scanle-content{
      height: 32px;
      width: 70px;
      background: rgba(86, 97, 114,0.7);
      border-radius: 4px;
      line-height: 32px;
      text-align: center;
    }
  }

  .data-list{
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 12px;
    background: rgba(62,71,84,0.7);

    border-radius: 6px;
    .btn-item{
      display: flex;
      gap: 8px;
      align-items: center;
      .item-img{
        width: 32px;
        height: 32px;
      }
      .data-desc{
        font-family: AlibabaPuHuiTi_2_75_SemiBold;
        font-size: 14px;
        color: #D9E7FF;
        line-height: 20px;
        text-shadow: 0px 0px 8px #00498C;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

    }
  }
}
</style>